import { render, staticRenderFns } from "./FontFaces.vue?vue&type=template&id=30bcaa75&"
import script from "./FontFaces.vue?vue&type=script&lang=ts&"
export * from "./FontFaces.vue?vue&type=script&lang=ts&"
import style0 from "./FontFaces.vue?vue&type=style&index=0&id=30bcaa75&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports